module.exports = __webpack_public_path__ + "static/banner01-0020a0ba100b8946501672edef3d652a.png";